import React from "react";

import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";

export interface ContainerProps {
  children?: React.ReactNode;
}

export const Container = ({ children }: ContainerProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        height: "100%",
        minHeight: 0,
        backgroundColor: theme.igBackgroundColors.baseLightHigh,
      }}
    >
      {children}
    </Stack>
  );
};
